define([
    "./monitoringTripStartOverviewModule",
    "./monitoringTripStartOverviewController"
], function () {
});